<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const i18nScope = 'components.sales_dashboard';

  const props = defineProps({
    // [{ carousel_id, title, sales }], already ranked by sales. A carousel
    // deleted since the sales were made comes with no title.
    carousels: { type: Array, required: true }
  });

  const maxSales = computed(() => Math.max(...props.carousels.map((entry) => entry.sales), 1));

  function label(entry) {
    return entry.title || t(`${i18nScope}.deleted_carousel`, { id: entry.carousel_id });
  }

  function barWidth(entry) {
    return `${Math.max((entry.sales / maxSales.value) * 100, 1)}%`;
  }

  function formatCount(value) {
    return new Intl.NumberFormat().format(value);
  }
</script>

<template>
  <p v-if="carousels.length === 0" class="text-center text-muted py-4 mb-0">{{ t(`${i18nScope}.no_data`) }}</p>
  <!-- The list is ranked, so an ordered list is the honest markup; the bars
       only restate the figures and stay decorative. -->
  <ol v-else class="list-unstyled mb-0">
    <li v-for="entry in carousels" :key="entry.carousel_id" class="top-carousel mb-2">
      <div class="d-flex justify-content-between align-items-baseline gap-3">
        <span class="text-truncate">{{ label(entry) }}</span>
        <span class="fw-semibold text-nowrap">{{ formatCount(entry.sales) }}</span>
      </div>
      <div class="bar-track" aria-hidden="true">
        <div class="bar" :style="{ width: barWidth(entry) }"></div>
      </div>
    </li>
  </ol>
</template>

<style scoped>
  .top-carousel .bar-track {
    background: #e9ecef;
    border-radius: 2px;
    height: 6px;
    overflow: hidden;
  }

  .top-carousel .bar {
    /* Same hue as the first series of the sibling charts */
    background: #0d6efd;
    border-radius: 2px;
    height: 100%;
  }
</style>
